(function () {
  "use strict";

  function initTabs(config) {
    const tabSelector = config.tabSelector;
    const panelSelector = config.panelSelector;
    const activeTabClass = config.activeTabClass || "is-active";
    const activePanelClass = config.activePanelClass || "is-show";

    const tabs = document.querySelectorAll(tabSelector);
    const panels = document.querySelectorAll(panelSelector);
    if (!tabs.length) return;

    tabs.forEach((tab, i) => {
      if (i === 0) {
        tab.classList.add(activeTabClass);
        if (panels[i]) panels[i].classList.add(activePanelClass);
      }

      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.classList.remove(activeTabClass));
        panels.forEach((p) => p.classList.remove(activePanelClass));
        tab.classList.add(activeTabClass);
        const index = Array.from(tabs).indexOf(tab);
        if (panels[index]) panels[index].classList.add(activePanelClass);

        if (config.onTabChange) config.onTabChange(index, panels[index]);
      });
    });
  }

  function initFeaturedProductTabs() {
    initTabs({
      tabSelector: ".blueLightProduct .screen-tab",
      panelSelector: ".blueLightProduct .screen-product",
      activeTabClass: "is-activee",
      activePanelClass: "is-showw",
    });

    const firstRadio = document.querySelector(
      '.blueLightProduct .screen-tab input[type="radio"]'
    );
    if (firstRadio) {
      firstRadio.checked = true;
      const handle = firstRadio.closest(".screen-tab")?.getAttribute("producthandle");
      if (handle) {
        const block = document.querySelector("." + handle);
        if (block) block.style.visibility = "visible";
      }
    }

    document.querySelectorAll(".blueLightProduct .screen-tab").forEach((tab) => {
      tab.addEventListener("click", () => {
        document
          .querySelectorAll('.blueLightProduct input[type="radio"]')
          .forEach((r) => {
            r.checked = false;
          });
        document.querySelectorAll(".blueLightProduct .sliderBlock").forEach((el) => {
          el.style.visibility = "hidden";
        });
        const radio = tab.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
        const handle = tab.getAttribute("producthandle");
        if (handle) {
          const block = document.querySelector("." + handle);
          if (block) block.style.visibility = "visible";
        }
      });
    });

    initTabs({
      tabSelector: ".blueLightProduct .tabb",
      panelSelector: ".blueLightProduct .panell",
      activeTabClass: "is-active",
      activePanelClass: "is-show",
    });
  }

  function initTabSwitchingSection() {
    initTabs({
      tabSelector: ".tab-switching-sec .taab",
      panelSelector: ".tab-switching-sec .pannel",
      activeTabClass: "is-acctive",
      activePanelClass: "is-shhow",
      onTabChange: () => {
        if (window.theme && theme.Carousel) {
          theme.Carousel.refreshAll(".tab-switching-sec .panel-slider");
        }
      },
    });
  }

  window.theme = window.theme || {};
  theme.blueLightTabs = {
    init: initTabs,
    initFeaturedProductTabs: initFeaturedProductTabs,
    initTabSwitchingSection: initTabSwitchingSection,
  };

  document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".blueLightProduct")) initFeaturedProductTabs();
    if (document.querySelector(".tab-switching-sec")) initTabSwitchingSection();
  });
})();
